import {SavedLocation} from "components/src/auth/SavedLocation";
import {Loading} from "components/src/common/Loading";
import {useAuthenticatedUserContext} from "components/src/hook/UseAuthenticatedUserContext";
import React from 'react'
import {useLocation} from 'react-router-dom';

interface AuthenticatedRouteProps {
    children: React.ReactNode
}

/**
 * Represents a route component that stores the location in the session storage if the user is not authenticated
 * so the app can redirect to the stored location if the user is logged in
 *
 * @param {Object} props - The component props.
 * @param {JSX.Element} props.children - The content to render if user is authenticated.
 *
 * @returns {JSX.Element} - The rendered component.
 */
export const AuthenticatedRoute = ({children} : AuthenticatedRouteProps) =>
{
    const {authenticatedUser} = useAuthenticatedUserContext();
    const location = useLocation()

    const authenticated = authenticatedUser !== undefined && authenticatedUser.length > 0;

    // if the user is not authenticated, save the location
    // after successful authentication, the saved location can then be used to navigate tp the saved location
    if (!authenticated)
    {
        let savedLocation = location.pathname;

        if (!savedLocation.endsWith("/")) {
            savedLocation = savedLocation + "/";
        }

        savedLocation = savedLocation + location.search;

        // success URL should be excluded
        // this is needed when 2FA is enabled because when the 2FA code is not yet provided, a redirect from
        // success to success will be executed which should not result in overwriting the stored location
        if (!location.pathname.endsWith("/success")) {
            SavedLocation.setSavedLocation(savedLocation);
        }
    }

    return !authenticated ? <Loading/> : (
        children
    );
};
